import { escapeHtml } from 'src/app/shared/helpers/html-escape.helper';

export interface TemplateNameCellRow {
  name: string;
  isDefault: boolean;
  isShared: boolean;
}

export function buildTemplateNameCell(row: TemplateNameCellRow, translate: (key: string) => string): string {
  const icon = row.isDefault ? 'star' : (row.isShared ? 'group' : 'person');
  const badge = row.isDefault
    ? `<span class="template-badge template-badge--default">${escapeHtml(translate('Default'))}</span>`
    : '';
  return `<span class="template-name"><i class="material-icons template-name__icon">${icon}</i><span class="template-name__text">${escapeHtml(row.name)}</span>${badge}</span>`;
}
